module.exports = __webpack_public_path__ + "Poppins-SemiBold.f018d93c4bd9b0bbdfb8.ttf";


//////////////////
// WEBPACK FOOTER
// C:/wamp64/www/Uclics/demo/angular/src/assets/fonts/Poppins-SemiBold.ttf
// module id = ../../../../../src/assets/fonts/Poppins-SemiBold.ttf
// module chunks = styles